import { useQuery } from '@tanstack/react-query';

import fetchProduct from '../apis/fetchProduct';

export default function useGetProductById(productDocId) {
  return useQuery({
    queryKey: ['getProductById', productDocId],
    queryFn: () => fetchProduct(productDocId),
    enabled: !!productDocId,
    staleTime: 10 * 60 * 1000,
  });
}
